const FormField = ({field, value, isEdit, onChange}) => {
  const labelStyle = "text-sm font-medium text-[#2ba9cd]";
  const inputStyle =
    "p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 transition-all";

  return (
    <div className="flex flex-col">
      <label className={labelStyle} htmlFor={field.name}>
        {field.label}
      </label>
      {isEdit ? (
        field.type === "textarea" ? (
          <textarea
            id={field.name}
            name={field.name}
            value={value}
            onChange={onChange}
            className={`${inputStyle} resize-none`}
            rows="3"
          />
        ) : (
          <input
            id={field.name}
            type={field.type}
            name={field.name}
            value={value}
            onChange={onChange}
            className={inputStyle}
          />
        )
      ) : (
        <p className="p-2 bg-gray-50 border border-gray-200 rounded-lg text-gray-700">
          {value || "--"}
        </p>
      )}
    </div>
  );
};

export default FormField;
